// extracted by mini-css-extract-plugin
export default {"wrapper":"EditProjectsForm_wrapper__BNvSl","submitWrapper":"EditProjectsForm_submitWrapper__tZ1xX"};